import { mapState } from 'vuex';
import { Base64 } from 'js-base64';
import { apiCallers } from '@/api/apiRequest';

import InsuranceCard from '@/components/common/insurance-card.vue';
import NRadio from '@/components/common/n-radio';
import ScrollHandler from '@/mixins/scrollHandler.js';
import TrackingHandler from '@/mixins/trackingHandler.js';

export default {
  components: {
    InsuranceCard,
    NRadio
  },

  mixins: [
    ScrollHandler,
    TrackingHandler
  ],

  data: () => ({
    subjectId: '',
    rented: null,
    insurances: [],

    subjects: [
      {
        value: 'Haus',
        text: 'Haus',
      },
      {
        value: 'Eigentum',
        text: 'Eigentumswohnung',
      },
      {
        value: 'Miete',
        text: 'Mietwohnung',
      },
    ],

    rentedOptions: [
      {
        text: 'Ja',
        value: true,
      },
      {
        text: 'Nein',
        value: false,
      },
    ],

    trackingModuleType: 'bedarfscheck'
  }),

  computed: {
    ...mapState([
      'appConfigs'
    ]),

    config () {
      return this.appConfigs[this.$options.configIndex] || {};
    },

    apiRequest () {
      return apiCallers[this.config.app];
    },
  },
  methods: {
    decodeHtml (value) {
      return value
        ? Base64.decode(value)
        : '';
    },

    loadInsurances () {
      if (this.rented === null) {
        return;
      }

      const params = {
        type: this.subjectId,
        rented: this.rented,
        customer: this.config.theme
      };

      return this.apiRequest
        .get(this.config.paths.calc, {
          params
        })
        .then(res => {
          this.insurances = res.data.insurances || [];

          if (this.insurances.length > 0) {
            this.$nextTick(() => {
              this.scrollToElement('insurance-list', 0);
            });
          }
        });
    },

    onSelectSubject(value) {
      this.subjectId = value;
      this.rented = null;
      this.insurances = [];

      let actionType = '';

      if (value === 'Miete') {
        this.rented = false;
        this.loadInsurances();
        actionType = '01/mietwohnung';
      } else {
        this.scrollToElement('rented', 0);
        actionType = value === 'Haus'
          ? '01/haus'
          : '01/eigentumswohnung';
      }

      // console.log('actionType: ', actionType);
      this.triggerActionEvent(actionType, this.trackingModuleType);
    },

    onSelectRented(value) {
      this.rented = value;
      this.loadInsurances();

      const actionType = value === true
        ? '02/vermietet_ja'
        : '02/vermietet_nein';

      // console.log('actionType: ', actionType);
      this.triggerActionEvent(actionType, this.trackingModuleType);
    },
  }
};


// WEBPACK FOOTER //
// ./src/apps/bedarfscheck_wohnen/logic.js